import { render } from "./BurgerMenu.vue?vue&type=template&id=11c21bc8"
import script from "./BurgerMenu.vue?vue&type=script&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&lang=js"
script.render = render

export default script